module.exports = __webpack_public_path__ + "static/media/10_Magic_Flakes.35e2b495.png";